import { soilColors, IGenericAnalysis, OmniaDialogSize } from "../omnia"
import { IAnalysisValueColumn, ISoilService } from "../types"
import { TableColumns } from "./columns"
import { RowViewModel } from "./rowViewModel";

export class TableView {

    protected _key: string;
    protected _name: string;
    protected _template: string;

    constructor(private _nitrogen: boolean, private _fields: boolean, private _zones: boolean, protected _views?: TableView[], private _hsa?: boolean, private _pcn?: boolean) {
    }

    get key(): string {
        return this._key;
    }

    get name(): string {
        return this._name;
    }

    get views(): TableView[] {
        return this._views;
    }

    get editComponent(): string {
        return this._nitrogen ? "omnia-soil-editor-nitrogen" : this.hsa ? "omnia-soil-assessment-edit" : this.pcn ? "omnia-soil-editor-pcn" : "omnia-soil-editor-soil";
    }

    get editPopupSize(): OmniaDialogSize {
        return "lg"
    }

    get editPopupClass() {
        return undefined
    }

    get zones(): boolean {
        return this._zones;
    }

    get fields(): boolean {
        return this._fields;
    }

    get analysis(): boolean {
        return !this._fields;
    }

    get identifierPropertyName(): string {
        return this._nitrogen ? "NitrogenAnalysisId" : "SoilAnalysisId";
    }

    get standardAnalysis(): boolean {
        return !this._nitrogen;
    }

    get nitrogenAnalysis(): boolean {
        return this._nitrogen;
    }

    get hsa(): boolean {
        return this._hsa;
    }

    get pcn(): boolean {
        return this._pcn;
    }

    get fieldsView(): boolean {
        return this._fields;
    }

    get analysisColumns(): IAnalysisValueColumn[] {
        return undefined
    }

    get template(): string {
        return this._template;
    }

    getAnalyses(svc: ISoilService): IGenericAnalysis[] {
        return undefined
    }

    getColumnsPopupConfig(columns: TableColumns): { columns: IAnalysisValueColumn[], analysisColumns: IAnalysisValueColumn[] } {
        return undefined
    }

    getGaugeStyle(col: IAnalysisValueColumn, value: number, row: RowViewModel) {
        return soilColors.getGaugeStyle(value, col.key || col.name)
    }
}
